import { IkasCategoryPathItem } from ".";
import { IkasCategoryTranslation } from "../translations";

export function initIkasCategoryPathItem(
  categoryPathItem: IkasCategoryPathItem,
  locale: string | null
) {
  if (categoryPathItem.translations && locale) {
    setTranslations(categoryPathItem, categoryPathItem.translations, locale);
    delete categoryPathItem.translations;
  }
}

function setTranslations(
  categoryPathItem: IkasCategoryPathItem,
  translations: IkasCategoryTranslation[],
  locale: string
) {
  if (translations && translations.some((t) => t.locale === locale)) {
    const localeTranslations = translations.find((t) => t.locale === locale);

    if (localeTranslations?.name)
      categoryPathItem.name = localeTranslations.name;
  }
}
